<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <div class="content">
    <h1>{{ $t('signingOut') }}</h1>
  </div>
</template>

<script>
import Mgr from '@/services/SecurityService';

export default {
  name: 'Logout',
  data() {
    return {
      mgr: new Mgr(),
    };
  },
  async mounted() {
    console.debug("Logout mounted")
    if (this.mgr.getUser()) {
      await this.mgr.signOut();
    } else {
      // this.$router.push('/');
    }
  },
};
</script>
